import { Form } from 'react-bootstrap';
import { useFieldArray } from "react-hook-form";
import { AiOutlinePlus } from "react-icons/ai";
import { IoMdClose } from "react-icons/io";
import Swal from 'sweetalert2';
import classNames from "classnames";

// Custom Component
import TeamAgeGroup from './TeamAgeGroup';
import ErrorAlert from '../../Alert/ErrorAlert';

// Utils
import { detectMenEvent, detectWomenEvent } from '../../../utils/helper';

const TeamCategory = ({ teamIndex, allWatchedValues, control, register, errors, eventTypeList, tournament }) => {
    const { fields, remove, append } = useFieldArray({
        control,
        name: `team_events[${teamIndex}].event_details`
    });

    return <div className='mt-3 p-3 border bg-gray rounded'>
        {fields?.length > 0 && fields?.map((item, index) => {
            return <div key={item.id}>
                <div className={classNames('d-flex justify-content-between align-items-center', {
                    'mt-3': index > 0
                })}>
                    <span className='fw-500 text-dark'>Categories</span>
                    {fields?.length > 1 && <IoMdClose role='button' color='red' size={20} onClick={() => {
                        Swal.fire({
                            title: "Are you sure ?",
                            text: "You won't be able to revert this!",
                            icon: "warning",
                            showCancelButton: true,
                            showCloseButton: true,
                            confirmButtonColor: "#FA5000",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes, Delete It!",
                            reverseButtons: true,
                            customClass: {
                                container: 'delete-swal-container',
                                title: 'fs-20 mb-3'
                            }
                        }).then((result) => {
                            if (result.isConfirmed) {
                                remove(index)
                            }
                        });
                    }} />}
                </div>
                <div className='d-flex flex-wrap align-items-center'>
                    {eventTypeList?.length > 0 && eventTypeList?.map((eventTypeItem, eventTypeIndex) => {
                        return <Form.Group key={`team-event${index}-${eventTypeIndex}`}>
                            <Form.Check
                                className='event-type ps-0 mt-3 me-2'
                                type='radio'
                                label={<span role='button' className={classNames('p-2', {
                                    'bg-primary text-light rounded': allWatchedValues?.team_events[teamIndex]?.event_details[index]?.event_type === eventTypeItem?.value,
                                    'bg-event rounded': allWatchedValues?.team_events[teamIndex]?.event_details[index]?.event_type !== eventTypeItem?.value
                                })}>
                                    {detectMenEvent({
                                        event: eventTypeItem?.value,
                                        color: allWatchedValues?.team_events[teamIndex]?.event_details[index]?.event_type === eventTypeItem?.value && 'white',
                                        className: 'me-2'
                                    })}
                                    {detectWomenEvent({
                                        event: eventTypeItem?.value,
                                        color: allWatchedValues?.team_events[teamIndex]?.event_details[index]?.event_type === eventTypeItem?.value && 'white',
                                        className: 'me-2'
                                    })}
                                    {eventTypeItem?.label}
                                </span>}
                                // id={`team-event-${eventTypeItem?.value?.toLowerCase()}-${teamIndex}-${index}-${eventTypeIndex}`}
                                id={`${eventTypeItem?.value?.toLowerCase()}${teamIndex}${index}${eventTypeIndex}`}
                                // id={`team-event[${teamIndex}][${index}][${eventTypeIndex}]`}
                                value={eventTypeItem?.value}
                                {...register(`team_events[${teamIndex}].event_details[${index}].event_type`)}
                                disabled={allWatchedValues?.team_events[teamIndex]?.event_details?.find((eventItem, eventIndex) => eventItem.event_type === eventTypeItem?.value && index !== eventIndex)}
                            />
                        </Form.Group>
                    })}
                </div>
                <TeamAgeGroup
                    teamIndex={teamIndex}
                    nestIndex={index}
                    allWatchedValues={allWatchedValues}
                    tournament={tournament}
                    {...{ control, register, errors }}
                />
            </div>
        })}
        <div role='button' className='d-flex justify-content-center align-items-center mt-3 border rounded py-2' onClick={() => {
            if (allWatchedValues?.team_events[teamIndex]?.event_details?.length >= eventTypeList?.length) {
                ErrorAlert(`You can't add more than ${eventTypeList?.length} event`)
            } else {
                append({
                    event_type: eventTypeList.find(event => !allWatchedValues?.team_events[teamIndex]?.event_details?.map(item => item?.event_type).includes(event?.value))?.value,
                    age_groups: [
                        {
                            age_group: "BELOW_AGE",
                            age_value: "",
                            number_of_males: "",
                            number_of_females: "",
                            allowed_registrations: "",
                            is_disabled: true,
                            allow_proffesional_players: false
                        }
                    ]
                })
            }
        }}>
            <AiOutlinePlus className='me-2' size={25} />
            <span className='fs-14 fw-600 text-secondary'>Add more Categories</span>
        </div>
    </div>
};

export default TeamCategory;